import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class OtherSuggestion extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "status", Model.attribute('status'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "category", Model.hasOne('category'));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "mergedToNominee", Model.hasOne('mergedToNominee'));
  }
  isPending() {
    return this.status() === 'pending';
  }
  isApproved() {
    return this.status() === 'approved';
  }
  isRejected() {
    return this.status() === 'rejected';
  }
  isMerged() {
    return this.status() === 'merged';
  }
}
flarum.reg.add('huseyinfiliz-awards', 'common/models/OtherSuggestion', OtherSuggestion);